import { useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';

export const SCREEN_BIGMOBILE = 480;
export const SCREEN_NORMAL = 768;
export const SCREEN_WIDE = 1024;

type AspectRatioMap = {
  small: string;
  medium: string;
  large: string;
  xlarge: string;
};

export function resolveAspectRatio(width: number, map: AspectRatioMap): string {
  if (width < SCREEN_BIGMOBILE) return map.small;
  if (width < SCREEN_NORMAL) return map.medium;
  if (width < SCREEN_WIDE) return map.large;
  return map.xlarge;
}

export function useAspectRatio(map: AspectRatioMap): string {
  const { width } = useWindowDimensions();
  return resolveAspectRatio(width, map);
}
